var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.78,
    height: 25.78,
    viewBox: "0 0 25.78 25.78",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(-226.97)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Down",
    transform: "translate(226.97)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4981",
    "data-name": "Path 4981",
    d: "M12.89,0A12.89,12.89,0,1,1,0,12.89,12.89,12.89,0,0,1,12.89,0Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4988",
    "data-name": "Path 4988",
    d: "M1,3.293C2.316,1.332,3.248.914,3.9,1.014c2.233.338,2.461,6.881,4.56,7.047,1.145.091,1.634-1.814,2.9-1.865,1.741-.071,3.3,3.421,4.352,6.425",
    transform: "translate(4.532 6.08)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDown);
export default __webpack_public_path__ + "static/media/down.bd32787f5cac226a64130224ce6006f8.svg";
export { ForwardRef as ReactComponent };